import React, { useEffect, useRef } from 'react';
import ErrorBoundary from 'src/components/10-atoms/ErrorBoundary';
import WidgetErrorFallback from 'src/components/10-atoms/ErrorBoundary/WidgetErrorFallback';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import createThemedStyle from 'src/customizations/themes/utils/createThemedStyles';
import useCallbackWithCtx from 'src/hooks/useCallbackUtils/useCallbackWithCtx';
import useStableCallback from 'src/hooks/useCallbackUtils/useStableCallback';
import QuillEditor from './QuillEditor';
import { getDiffViewDelta } from './QuillEditor/utils/diff';
import { normalizeMathField } from './utils/mathField';
const HTMLDiffRenderer = ({ oldHtml: oldHtml, newHtml: newHtml, showOnlyDiff = true, enableCachedImage, onError, ...columnProps }) => {
    const [{ theme }] = useTheme(stylesGenerator);
    const editorRef = useRef(null);
    const quillRef = useRef(undefined);
    const updateEditorContent = useStableCallback(() => {
        try {
            const diffViewDelta = getDiffViewDelta(theme, quillRef.current, normalizeMathField(oldHtml ?? ''), normalizeMathField(newHtml ?? ''), { showOnlyDiff });
            editorRef.current?.setDelta(diffViewDelta);
        }
        catch (error) {
            onError?.(error);
        }
    });
    const handleEditorChange = useCallbackWithCtx((ctx, quill) => {
        if (quill) {
            quillRef.current = quill;
            updateEditorContent();
        }
    }, { theme, oldHtml, newHtml, showOnlyDiff });
    useEffect(() => {
        if (quillRef.current) {
            updateEditorContent();
        }
    }, [newHtml, oldHtml, showOnlyDiff]);
    return (React.createElement(ErrorBoundary, { renderError: () => (React.createElement(WidgetErrorFallback, { message: "Unable to display this revision", ...columnProps })) },
        React.createElement(QuillEditor, { ref: editorRef, readOnly: true, enableCachedImage: enableCachedImage, initialValue: '', onEditorChanged: handleEditorChange, ...columnProps })));
};
const stylesGenerator = createThemedStyle(({}) => ({}));
export default HTMLDiffRenderer;
